<template>
  <div class="dialog_container">
    <el-dialog
      title="新增证件"
      :visible="dialogShow"
      width="405px"
      @close="dialogClose"
      top="30vh"
      append-to-body
      :close-on-click-modal="false"
    >
      <div class="dialog_box">
        <el-form
          ref="addForm"
          class="add_staff_form"
          :model="addForm"
          label-width="100px"
          :rules="redactRules"
        >
          <el-form-item label="证件类型：" prop="type">
            <el-select v-model="addForm.type" placeholder="请选择证件类型">
              <el-option
                v-for="item in cerTypeList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="上传证件：" prop="image">
            <div class="certificate">
              <el-upload
                class="avatar-uploader"
                action="http://47.101.220.89:8687/file/uploadFile"
                :show-file-list="false"
                :before-upload="beforeAvatarUpload"
                :headers="headers"
                :http-request="uploadFile"
              >
                <div v-if="addForm.image">
                  <img :src="imgHttp + addForm.image" class="avatar" />
                </div>
                <div v-else>
                  <div class="card_title">机动车行驶证1</div>
                  <img
                    class="uploading_icon"
                    src="../../../../../static/images/idCard_icon.png"
                    alt=""
                  />
                </div>
              </el-upload>
            </div>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="btn" @click="dialogClose">取 消</el-button>
        <el-button class="btn btn_ok" @click="confirm('addForm')"
          >保 存</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import config from '@/utils/config';
export default {
  name: "",
  data() {
    return {
      addForm: {
        carId: 0,
        image: "",
        isBase: 2,
        type: null,
      },
      cerTypeList: [],
      redactRules: {
        type: [
          { required: true, message: "请选择证件类型", trigger: "change" },
        ],
        image: [
          { required: true, message: "请选择上传证件", trigger: "change" },
        ],
      },
      headers: {},
      imgHttp: "",
    };
  },
  components: {},
  props: {
    dialogShow: {
      type: Boolean,
      default: false,
    },
    carId: Number,
  },
  watch: {
    dialogShow(val) {
      if (val) {
        console.log(val);
        this.headers = {
          Authorization: sessionStorage.getItem("Token"),
          "Content-Type": "multipart/form-data",
        };
        this.imgHttp = config.baseUrl;
        (this.addForm = {
          carId: this.carId,
          image: "",
          isBase: 2,
          type: null,
        }),
        this.$http.getCarCertificateSelect().then((res) => {
          if (res.code === 0) {
            this.cerTypeList = res.data;
          } else {
            this.$message.info(res.msg);
          }
        });
      }
    },
  },
  created() {},
  methods: {
    confirm(formName) {
      this.$refs[formName].validate((valid) => {
        if (!valid) return false;
        this.$http.updateCarCertificate(this.addForm).then((res) => {
          if (res.code === 0) {
            this.$message.success(res.msg);
            this.$parent.getList();
            this.addForm = {};
            this.$emit("update:dialogShow", false);
          } else {
            this.$message.info(res.msg);
          }
        });
      });
    },
    dialogClose() {
      this.$emit("update:dialogShow", false);
    },
    uploadFile(file) {
      var that = this;
      console.log(file);
      const formData = new FormData();
      formData.append("file", file.file);
      this.$http.uploadFile(formData).then((res) => {
        that.addForm.image = res.msg;
      });
    },
    beforeAvatarUpload(file) {
      console.log(file.type);
      const isType =
        file.type == "image/jpg" ||
        file.type == "image/jpeg" ||
        file.type == "image/png" ||
        file.type == "application/pdf" ||
        file.type == "application/msword" ||
        file.type == "application/vnd.openxmlformats-officedocument.wordprocessingml.document";;
      const isLt20M = file.size / 1024 / 1024 < 20;

      if (!isType || !isLt20M) {
        this.$message.error(
          "请上传格式为jpg、jpeg、png、pdf、doc、docx且大小不超过20M的图片或文件"
        );
      }
      return isType && isLt20M;
    },
  },
};
</script>

<style lang="less" scoped>
@import "../redact";
.upload_img {
  width: 250px;
  height: 163px;
  background: #f7f7fc;
  border: 1px solid #e5e5e5;
}
/deep/.el-input__inner {
  width: 250px;
}
.certificate {
  .avatar-uploader .el-upload {
    border: 1px dashed #dcdfe6;
    border-radius: 4px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  // .el-form-item__content {
  //     line-height: 0!important;
  //   }

  .avatar-uploader {
    width: 250px;
    height: 158px;
    border-radius: 2px;
    border: 1px solid #dcdfe6;
    display: flex;
    justify-content: center;
    align-items: center;

    .card_title {
      font-size: 16px;
      font-family: PingFang SC-Medium, PingFang SC;
      font-weight: 500;
      color: #000000;
    }

    .uploading_icon {
      width: 106px;
      height: 86px;
      margin-top: 15px;
    }

    .avatar {
      width: 250px;
      height: 158px;
      margin-top: 16px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/carAdmin/carTechnology_component/tabDialog/addPapersResid.vue